import { useAuth } from '../stores/auth';

/** useCan('workOrders.assign') — render-time gate only; the API enforces the real rule. */
export function useCan(permission: string): boolean {
  return useAuth((s) => s.can(permission));
}

/**
 * useLimit('applications.discountLimitPercent') — a number stored inside the permission (null = unlimited, all access;
 * missing = 0). Render-time only, e.g. "you may approve up to N%"; the API enforces it (403 DISCOUNT_OVER_LIMIT).
 */
export function useLimit(key: string): number | null {
  return useAuth((s) => {
    const u = s.user;
    if (!u) return 0;
    if (u.allAccess) return null;
    const v = u.limits?.[key];
    return v === undefined ? 0 : v;
  });
}

export function useCanPage(page: string): boolean {
  return useAuth((s) => s.canAccessPage(page));
}
